import { useTranslation as e } from "../../i18n/hooks.js";
import { breakpointQueries as t } from "../../shared/breakpoints.js";
import { useMediaQuery as n } from "../../shared/hooks/use-media-query.js";
import { Actions as r } from "../primitive/actions.js";
import { Calendar as i, DoubleCalendar as a } from "../primitive/calendar.js";
import { DateField as o } from "../primitive/date-field.js";
import { DateRangeSummary as s } from "../primitive/date-range-summary.js";
import { FilterPresets as c } from "../primitive/filter-presets.js";
import { Popup as ee } from "../primitive/popup.js";
import { useDateFnsLocale as te } from "../utils/use-date-fns-locale.js";
import { useDateRange as l } from "./use-date-range.js";
import { useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { formatDate as m } from "@systemeio/util";
import { enUS as h } from "date-fns/locale/en-US";
//#region src/date-picker/date-range-picker/date-range-picker.tsx
function g({ date: g, minDate: _, maxDate: v, maxInterval: y, timezone: b, customFilters: x, disabled: S, intlLocale: C, label: w, placeholder: T, showFilterPresets: E = !0, clearable: D, required: O, size: ne, error: re, description: ie, wrapperButtonInputClassName: ae, labelClassName: k, getDefaultDate: A, onChange: j }) {
	let { t: M } = e(), N = n(t.isMobile, { initializeWithValue: !1 }), [P, F] = u(!1), [I, L] = u(h);
	te(C, L);
	let { activeFilter: R, appliedDateSince: z, appliedDateTill: B, filterPresets: V, handleApply: H, handleChange: U, handleClear: W, resetDraftRange: G, selectedDateSince: K, selectedDateTill: q, setActiveFilter: J } = l({
		customFilters: x,
		date: g,
		getDefaultDate: A,
		intlLocale: C,
		maxInterval: y,
		minDate: _,
		onChange: j,
		timezone: b
	}), Y = (e) => e ? m(e) : "-", X = () => {
		F(!1);
	}, Z = () => {
		H(), X();
	}, Q = () => {
		W(), X();
	}, oe = (e) => {
		F(e), e || G();
	}, $ = new Intl.DateTimeFormat(C, {
		day: "numeric",
		month: "short",
		year: "numeric"
	}), se = z && B ? ((e, t) => e > t ? `${$.format(e)} - ${$.format(t)}` : $.formatRange(e, t))(z, B) : void 0;
	return /* @__PURE__ */ f(ee, {
		title: M("public_pages_purchase.date_picker.date_filter_title"),
		disabled: S,
		open: P,
		onClose: X,
		onOpenChange: oe,
		trigger: /* @__PURE__ */ f(o, {
			label: w,
			required: O,
			size: ne,
			error: re,
			description: ie,
			value: se,
			placeholder: T ?? M("public_pages_purchase.date_picker.title_dates"),
			disabled: S,
			clearable: D,
			focus: P,
			labelClassName: k,
			className: ae,
			onClear: Q
		}),
		triggerRender: /* @__PURE__ */ f("div", {
			"aria-label": w ? void 0 : T ?? M("public_pages_purchase.date_picker.title_dates"),
			className: "w-full text-left",
			role: "button",
			tabIndex: 0
		}),
		children: N ? /* @__PURE__ */ p(d, { children: [
			E && /* @__PURE__ */ f(c, {
				className: "px-4 py-3",
				disabled: S || !b,
				onChange: J,
				presets: V,
				value: R
			}),
			/* @__PURE__ */ f(i, {
				dateFormat: "MMMM d, yyyy",
				endDate: q,
				intlLocale: C,
				locale: I,
				maxDate: v,
				minDate: _,
				onChange: U,
				selected: K,
				selectsRange: !0,
				startDate: K
			}),
			/* @__PURE__ */ f(s, {
				className: "mx-4 my-3 justify-between",
				fromValue: Y(K),
				toValue: Y(q)
			}),
			/* @__PURE__ */ f(r, {
				className: "m-4 gap-3",
				applyDisabled: !K || !q || S,
				clearDisabled: S,
				onApply: Z,
				onClear: Q
			})
		] }) : /* @__PURE__ */ p("div", {
			className: "flex flex-row",
			children: [/* @__PURE__ */ p("div", {
				className: "flex flex-col",
				children: [
					/* @__PURE__ */ f(a, {
						dateFormat: "MMMM d, yyyy",
						endDate: q,
						intlLocale: C,
						locale: I,
						maxDate: v,
						minDate: _,
						onChange: U,
						selected: K,
						selectsRange: !0,
						startDate: K
					}),
					/* @__PURE__ */ f(s, {
						className: "mx-4 mb-5 grid grid-cols-2 gap-0 [&>div:last-child]:ml-2",
						fromValue: Y(K),
						toValue: Y(q)
					}),
					!E && /* @__PURE__ */ f(r, {
						className: "mr-4 mb-4 ml-auto",
						applyDisabled: !K || !q || S,
						clearDisabled: S,
						onApply: Z,
						onClear: Q
					})
				]
			}), E && /* @__PURE__ */ p("div", {
				className: "border-border-200 flex flex-col justify-between gap-2 border-l p-4",
				children: [/* @__PURE__ */ f(c, {
					disabled: S || !b,
					onChange: J,
					presets: V,
					value: R
				}), /* @__PURE__ */ f(r, {
					className: "flex-col",
					applyDisabled: !K || !q || S,
					clearDisabled: S,
					onApply: Z,
					onClear: Q
				})]
			})]
		})
	});
}
//#endregion
export { g as DateRangePicker };
